import router from '../../router'

export const lottery = {
    actions: {
        async onLotteryUserNoPermission(
            { state, getters, commit, dispatch },
            payload
        ) {
            if (getters.getServices && !getters.getServices[0]) {
                await dispatch('servicesFetch')
            }
            const services = getters.getServices
            const joinToLotteryService =
                services && services.find(service => service.code === 'mp_pp')

            joinToLotteryService &&
                router.push({
                    name: 'service',
                    params: { id: joinToLotteryService.id }
                })
        }
    }
}
